export default {
  'Primary navigation': 'Primary Navigation',
  'Utility navigation': 'Utility navigation',
  'User menu': 'User menu',
};
